@if ($type() == 'stat') {
    <div class="card stat" (click)="goTo()">
        <div class="body-wrapper">
            <div class="body">
                <div class="stat-counter">
                    <h2 class="m-0">{{$statCounter()}}</h2>
                </div>

                <div class="stat-label">
                    <h6 class="m-0">{{$statLabel()}}</h6>
                </div>

                <div class="chevron">
                    <i class="fas fa-chevron-right"></i>
                </div>
            </div>
        </div>
    </div>
} @else if ($type() == 'action') {
    <a class="action" [routerLink]="$actionRouterLink()" [externalLink]="$actionHref()" [target]="$actionHref() != null ? '_blank' : null">
        <div class="keep-left">
            <div class="keep-top">
                <div class="action-icon">
                    <i [class]="$actionIconClass()"></i>
                </div>
                <span class="action-title">{{$actionTitle()}}</span>
            </div>

            <div class="action-content">
                <span class="action-description">{{$actionDescription()}}</span>
            </div>
        </div>

        <div class="chevron">
            <i class="fas fa-chevron-right"></i>
        </div>
    </a>
}
